import React from 'react';
import { gql } from '@ts-gql/tag';
import { useMutation } from '@ts-gql/apollo';

const mutation = gql`
  mutation UpdateJobRecurrance($input: JobRecurrenceUpdateInput!) {
    updateJobRecurrance(input: $input) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/UpdateJobRecurrance').type;

export const useUpdateJobRecurrance = () => {
  const tuple = useMutation(mutation);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) =>
      _mutate({
        context: { service: 'core' },
        // TO DO: test multiple contexts (core and users) from refetch queries works
        refetchQueries: [
          'JobGetRecurrences',
          'GetJob',
          'GetNotificationCountForUser',
        ],
        // refetchQueries: [
        //   {
        //     query: jobGetRecurrences,
        //     context: { service: 'core' },
        //   },
        //   {
        //     query: getJob,
        //     variables: { cloudId: options.variables.cloudId },
        //     context: { service: 'core' },
        //   },
        //   {
        //     query: getNotificationCountForUser,
        //     context: { service: 'users' },
        //   },
        // ],
        awaitRefetchQueries: true,
        ...options,
      }),
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
